/**
 * 앱 디버그(로그·스캔·브리지·perf 콘솔) 공통 스위치.
 *
 * production 빌드(`build:aws` / staging / solarwiz, NODE_ENV=production)에서는 off.
 * yarn serve · jest(test) 에서는 on.
 */
export function isAppDebugEnabled() {
  return process.env.NODE_ENV !== 'production';
}
